// extracted by mini-css-extract-plugin
export default {"content":"Projects_content__fTxg6","projects":"Projects_projects__D1qA+"};